import React, { Component } from 'react';
import ReactDOM from "react-dom";

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import StrFormat from '../../components/StrFormat';

const styles = theme => ({
    bottomSpace: {
        height: '100px'
    },
    card: {
        margin: '15px',
        width: '400px',
        maxWidth: '90%',
        textAlign: 'left'
    },
    cardActions: {
        width: '100%',
        minHeight: '60px'
    },
    cardHeader: {
        marginBottom: '10px'
    },
    delivStatus: {
        color: '#444'
    },
    grid: {
        display: 'flex',
        flexWrap: 'wrap',
        alignIitems: 'center',
        justifyContent: 'center',
        marginTop: '15px',
        paddingBottom: '100px'
    },
    header: {
        color: "black",
        fontSize: '1.5em',        
        marginTop: '120px'
    },
    initialMessage: {
        marginTop:'100px'
    },
    input100: {
        marginTop: '15px',
        width: '100%'
    },
    label: {
        color: 'black',
        marginRight: '5px'
    },
    startBtn: {
        marginRight: '10px',
        marginTop: '5px',
        float: 'right'
    },
    tagStatus:{
        backgroundColor: '#eeeeee',
        height: '10px',
        marginBottom: '5px',
        marginTop: '-5px',
        width: '100%',
    },
    root: {
        marginTop:'-45px'
    }    
});

class Deliv extends Component{
    constructor(props){
        super(props);

        this.state = {};
        this.state.delivStartDates = this.props.deliveries.map(i=>{
            const obj = {};
            obj.key = i._key;
            obj.value = i.delivery_start_date || null;
            return obj;
        });

        this.btnStartClick = this.btnStartClick.bind(this);
        this.btnOrdersClick = this.btnOrdersClick.bind(this);
        this.dateChanged = this.dateChanged.bind(this);
        this.delivClick = this.delivClick.bind(this);
        this.sensors_txt = this.sensors_txt.bind(this);
    }

    componentDidMount(){
        this.updateDelivTags();
    }

    componentDidUpdate(){
        this.updateDelivTags();
    }

    btnStartClick(e){
        const key = e.target.parentElement.getAttribute('data-key');
        this.props.onDelivStartClick(key);
    }

    btnOrdersClick(e){
        const key = e.target.parentElement.getAttribute('data-key');
        this.props.onClick(key);
    }

    dateChanged(e) {
        const _key = e.currentTarget.id;
        let _date = e.currentTarget.value;

        if (_date==='') _date = new Date();

        const _delivStartDates = this.state.delivStartDates.map(i=>{
            return (i.key === _key)?()=>{
                i.value = _date;
                return i;
            }:i;
        });

        this.setState({"delivStartDates":_delivStartDates});

        const data = {
            key: _key,
            date: _date
        }
        this.props.onDelivStartUpd(data);
    }

    delivClick(e){
        if (e.target.parentElement.id === 'startBtn' ||
            e.target.parentElement.id === '') return;
        
        if (e.target.target) return;

        let parent = e.target.parentElement;
        while(parent && !parent.id){
            parent = parent.parentElement;
        }

        this.props.onClick(parent.id);
    }

    delivStartEditable(deliv){
        let acc = 0;
        deliv.orders.forEach(i=>{
            acc+=i._status;
        });
        return !acc>0;
    }

    getDate(date){
        let _date;

        if (!date || date.seconds === 0){
            _date = new Date();
        } else {
            _date = new Date(date.seconds*1000);
        }

        return moment(_date).format('YYYY-MM-DDTHH:mm');
    }
    
    orders_txt(items) {
        let entregues = items.reduce((c, i) => {
            c += i._status === 1 ? 1 : 0;
            return c;
        }, 0);

        return <StrFormat
                str={this.props.texts.ordersDeliv}
                args={[entregues, items.length]} />
    }

    sensors_txt(delivSensorUin) {
        if (this.props.sensors.length===0){return};

        let html = '<hr>';
        html = html + 
            `<style>
                .label {
                    color: black;
                    margin-right: 5px;
                }
                .url {
                    color: blue;
                }
            </style>`;
        
        this.props.sensors.forEach(i=>{
            if (i.sensors && i.uin.toString() === delivSensorUin){
                
                let maps_url = `http://maps.google.com/maps?q=${i.lat},${i.lng}`;

                let gps_time = 0;
                i.sensors.forEach(s=>{
                    if (new Date(s.gps_time) > new Date(gps_time)){
                        gps_time = s.gps_time;
                    }
                });
                
                if (new Date(i.gps_time) > new Date(gps_time)){
                    gps_time = i.gps_time;
                }
                
                html = html + 
                    `<div>
                        <span class='label'>Last Update:</span> 
                        <span>
                            ${ new Date(gps_time).toLocaleString() } 
                        </span>
                    </div>
                    <div>
                        <span class='label'>Location:</span>
                        <span>
                            <a class='url' target='_blank' href='${maps_url}'>
                                Google Maps
                            </a>
                        <span>
                    </div>`
                
                i.sensors.forEach(i=>{
                    html = html + (
                        `<div>
                            <span class="label">${i.name}:</span>
                            <span>${i.sensor_value}&deg;</span>
                        </div>`
                    );
                });
            }
        });

        return {__html: html};
    }

    updateDelivTags(){
        if (!this.props.deliveries || this.props.deliveries.length===0){
            return;
        }

        this.props.deliveries.forEach(i=>{
            let items = i.orders;

            let delivered = items.reduce((c, i) => {
                c += i._status === 1 ? 1 : 0;
                return c;
            }, 0);    

            const node = ReactDOM.findDOMNode(this);
            const tagStatus = node.querySelector('#tag_' + i.delivery);
            if (tagStatus){
                if (delivered===0){
                    tagStatus.style.backgroundColor = 'lightgrey';
                }

                if (delivered > 0 && delivered === items.length){
                    tagStatus.style.backgroundColor = 'green';
                }

                if (delivered > 0 && delivered < items.length){
                    tagStatus.style.backgroundColor = '#ffcc80'; //yellow
                }
            }
        });
    }
    
    render(){
        const { classes, texts } = this.props;
        return (
            <div className={classes.root}>
                <div className={classes.header}>{this.props.texts.deliveries}</div>
                {this.props.deliveries.length === 0 && (
                    <div className={classes.initialMessage}> 
                        texts.nodeliv
                    </div> )}
                <div className={classes.grid}>
                    {this.props.deliveries.map(deliv=>(
                        <Card 
                            id={deliv._key}
                            key={deliv._key} 
                            className={classes.card}
                            onClick={/*this.delivClick*/null}>
                            
                            <CardContent>
                                <Typography className={classes.cardHeader} variant="h5" 
                                    component="h2">
                                    {deliv.delivery}
                                </Typography>
                                <div id={'tag_' + deliv.delivery} className={classes.tagStatus}>
                                </div>
                                <Typography className={classes.delivStatus}>
                                    <b>{this.orders_txt(deliv.orders)}</b><br /><br />
                                </Typography>
                                <span className={classes.label}>
                                    {texts.cia}:</span> {deliv.branch_name}<br />

                                <span className={classes.label}>
                                    {texts.truck}:</span> {deliv.vehicle}<br />

                                <span className={classes.label}>
                                    {texts.plate}:</span> {deliv.plate_id}<br />
                                <br/>
                                <span className={classes.label}>
                                    {texts.sensor}:</span> {deliv.sensor_uin}<br />

                                <span 
                                    dangerouslySetInnerHTML={this.sensors_txt(deliv.sensor_uin)}>
                                </span>
                            <Divider />
                            {(this.delivStartEditable(deliv) &&
                                <TextField id={deliv._key}
                                    className={classes.input100}
                                    label={texts.inideliv2}
                                    placeholder=' '
                                    type="datetime-local"
                                    value={this.getDate(deliv.delivery_start_date)}
                                    onChange={this.dateChanged} />) ||
                            (!this.delivStartEditable(deliv) &&
                                <div>
                                {texts.delivery}
                                <TextField id={deliv._key}
                                    className={classes.input100}
                                    disabled={true}
                                    label={texts.inideliv2}
                                    placeholder=' '
                                    type="datetime-local"
                                    value={this.getDate(deliv.delivery_start_date)}
                                /></div>)}
                            </CardContent>
                            <Divider />
                            <CardActions className={classes.cardActions}>
                                {!deliv.delivery_start_date &&
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Button className={classes.startBtn}
                                                color="primary"
                                                id="startBtn"
                                                data-key={deliv._key}
                                                onClick={this.btnStartClick}>
                                                {texts.inideliv}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }
                                {deliv.delivery_start_date &&
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Button className={classes.startBtn}
                                                color="primary"
                                                id="startBtn"
                                                data-key={deliv._key}
                                                onClick={this.btnOrdersClick}>
                                                {texts.orders}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }
                            </CardActions>
                        </Card>
                    ))}
                    <div className={classes.bottomSpace}></div>
                </div>
            </div>
        );    
    }
}

export default withStyles(styles)(Deliv);


// WEBPACK FOOTER //
// ./src/components/Deliv/index.js